module.exports = __webpack_public_path__ + "img/computer3@2x.7accc078.png";